import { Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

// RAT-1861: read-only counterpart to LegalFieldsSection, reused by the
// Merchant/Organization/Seller detail pages so the same field set renders the
// same way everywhere. Renders a flat list of label/value rows (matching the
// existing Flex row styling on both detail pages) - designed to be dropped
// straight inside the caller's existing SimpleGrid, not to own the grid itself.

const DEFAULT_FIELD_NAMES = {
  legalName: 'legalName',
  taxId: 'NIF',
  vatNumber: 'vatNumber',
  addressLine1: 'legalAddressLine1',
  addressLine2: 'legalAddressLine2',
  zipCode: 'legalZipCode',
  city: 'legalCity',
  province: 'legalProvince',
  country: 'legalCountry',
};

const Row = ({ label, value }) => (
  <Flex
    alignItems={{ sm: 'start', md: 'center' }}
    direction={{ sm: 'column', md: 'row' }}
    gap="10px"
    padding="4px 8px"
    borderLeft="1px solid #ccc"
  >
    <Text fontWeight="normal">{label}:</Text>
    <Text fontWeight="semibold">{value || 'N/A'}</Text>
  </Flex>
);

Row.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
};

const LegalFieldsView = ({
  data,
  fieldNames: fieldNamesProp,
  showLegalNameAndTax = true,
  taxIdLabel = 'Tax ID',
}) => {
  const fieldNames = { ...DEFAULT_FIELD_NAMES, ...fieldNamesProp };

  return (
    <>
      {showLegalNameAndTax && (
        <Row label="Legal Name" value={data?.[fieldNames.legalName]} />
      )}
      <Row label="Address Line 1" value={data?.[fieldNames.addressLine1]} />
      <Row label="Address Line 2" value={data?.[fieldNames.addressLine2]} />
      <Row label="Zip Code" value={data?.[fieldNames.zipCode]} />
      <Row label="City" value={data?.[fieldNames.city]} />
      <Row label="Province" value={data?.[fieldNames.province]} />
      <Row label="Country" value={data?.[fieldNames.country]} />
      {showLegalNameAndTax && (
        <>
          <Row label={taxIdLabel} value={data?.[fieldNames.taxId]} />
          <Row label="VAT Number" value={data?.[fieldNames.vatNumber]} />
        </>
      )}
    </>
  );
};

LegalFieldsView.propTypes = {
  data: PropTypes.object,
  fieldNames: PropTypes.object,
  showLegalNameAndTax: PropTypes.bool,
  taxIdLabel: PropTypes.string,
};

export default LegalFieldsView;
